import React, { useEffect, useState } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { format } from "date-fns";
import styled from "styled-components";
import { useDispatch, useSelector } from "react-redux";

import DateRangePickerComponent from "../common/DateRangePickerComponent";
import { getDailyAnalytics } from "../../redux/slices/reportSlice";
import {
  axisProps,
  gridProps,
  compactNumber,
  ChartTooltip,
  ChartLegend,
  ChartEmpty,
} from "../common/chart";
import theme from "../../theme";

const Toolbar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  margin-bottom: 16px;
`;

const Dailychart = () => {
  const dispatch = useDispatch();
  const { dailyAnalytics } = useSelector((state) => state.report);

  const [dateRange, setDateRange] = useState(() => {
    const now = new Date();
    return {
      startDate: new Date(now.getFullYear(), now.getMonth(), 1),
      endDate: now,
    };
  });

  useEffect(() => {
    if (dateRange.startDate && dateRange.endDate) {
      const startDate = format(dateRange.startDate, "yyyy-MM-dd");
      const endDate = format(dateRange.endDate, "yyyy-MM-dd");
      dispatch(getDailyAnalytics({ startDate, endDate }));
    } else {
      dispatch(getDailyAnalytics());
    }
  }, [dispatch, dateRange]);

  const data =
    dailyAnalytics?.data?.map((item) => ({
      name: item?.date,
      Conversions: Number(item?.conversioncount) || 0,
    })) || [];

  const hasData = data.some((point) => point.Conversions > 0);

  return (
    <div>
      <Toolbar>
        <ChartLegend keys={["Conversions"]} />
        <DateRangePickerComponent
          dateRange={dateRange}
          onDateChange={setDateRange}
        />
      </Toolbar>

      {hasData ? (
        <ResponsiveContainer width="100%" height={320}>
          <BarChart
            data={data}
            margin={{ top: 8, right: 8, left: -12, bottom: 0 }}
          >
            <CartesianGrid {...gridProps} />
            <XAxis dataKey="name" {...axisProps} interval="preserveStartEnd" />
            <YAxis tickFormatter={compactNumber} {...axisProps} />
            <Tooltip
              cursor={{ fill: theme.color.surfaceAlt }}
              content={<ChartTooltip />}
            />
            <Bar
              dataKey="Conversions"
              fill={theme.chart[0]}
              radius={[6, 6, 0, 0]}
              maxBarSize={38}
            />
          </BarChart>
        </ResponsiveContainer>
      ) : (
        <ChartEmpty>No conversions in the selected date range.</ChartEmpty>
      )}
    </div>
  );
};

export default Dailychart;
